var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      staticClass: "message",
      domProps: { innerHTML: _vm._s(_vm.sanitizedText) },
    }),
    _vm._v(" "),
    _vm.isDisplayingButton
      ? _c(
          "div",
          {
            staticClass: "quick-reply-panel",
            staticStyle: { "margin-top": "10px" },
          },
          [
            _c(
              "button",
              {
                staticClass: "quick-reply-button",
                attrs: { type: "button" },
                on: { click: _vm.restart },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.message.content.live_chat.restart_button_title) +
                    "\n    "
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }